import React from 'react';
import { useFavIcon, useFontFamilies } from '@roc/feature-app-core';
import { UnAuthenticatedView } from './routes';
import { observer } from 'mobx-react';
import { environment } from './../environments/environment';
import { usePageTracking } from 'libs/feature-app-core/src/hooks/usePageTracking';

export const App = observer(() => {
  useFavIcon();
  useFontFamilies();
  usePageTracking(environment.gtmTrackingId);
  return <UnAuthenticatedView />;
});
